export enum TOAST_MESSAGES {
  UNAUTHORIZERD = 'Your session has expired. Please sign in to your account',
  SHOULD_AUTHORIZE = 'Please sign in to your account or create a new',

  SOMETHING_WRONG = 'Something went wrong. Please try again later',

  INVALID_CREDENTIALS = 'Invalid email or password',
}
